export default __webpack_public_path__ + "static/media/dot_extended-repair.0115e4b1.svg";